const convertResponseDataFromBackend = (response, field) => {
  switch (field.type) {
    case "picker": {
      if (response.value || !response.value.length) return null;
      return (response.value.values || []).map((r) =>
        parseInt(r.optionListValueID)
      );
    }
    case "address":
    case "date":
      return response.value;
    case "text":
    case "number": {
      return response.value.value;
    }
    default:
      return null;
  }
};

const convertResponseDataForBackend = (responseValue, field) => {
  if (
    (!responseValue && responseValue !== 0 && responseValue !== "0") ||
    !field?.type
  )
    return null;
  switch (field.type) {
    case "picker": {
      return {
        values: responseValue.map((optionListValueID) => ({
          optionListValueID,
        })),
      };
    }
    case "address":
    case "date": {
      return responseValue;
    }
    case "text":
    case "number": {
      return { value: responseValue };
    }
    default:
      return null;
  }
};

export { convertResponseDataFromBackend, convertResponseDataForBackend };
